import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { FilterViewManager } from '@bingads-webui-campaign/reports-v4-filter-view-manager';
import { filterSchemaProcessor } from './filter-schema-processor';
import { setTrimmedFilterDataOptionsSearchInsightsReport } from '../../helpers/dynamic-filter-options-helper';

export function FilterViewManagerWrapper({
  toolbarEditor, reportSchema, i18n, resetToolbarVisibility, onFilterChange, filters, permissions, isAccountScope,
}) {
  const [entitySchema, setEntitySchema] = useState(filterSchemaProcessor(reportSchema.Filters, i18n, permissions, isAccountScope));

  useEffect(() => {
    setEntitySchema(filterSchemaProcessor(reportSchema.Filters, i18n, permissions, isAccountScope));
  }, [reportSchema, i18n, permissions, isAccountScope]);

  useEffect(() => {
  }, [entitySchema]);

  return (
    <div>
      <FilterViewManager
        key={reportSchema.ReportType}
        entitySchema={entitySchema}
        i18n={i18n}
        updateToolbar={toolbarEditor.update}
        resetToolbarVisibility={resetToolbarVisibility}
        legacyI18n={i18n}
        hideSaveFilterButton
        setEditableFilter={(filterData) => {
          const editableFilter = reportSchema ? { ...filterData } : {};
          if (reportSchema.ReportType === 'SearchVerticalCategoryInsightsReport' || reportSchema.ReportType === 'SearchVerticalCategoryClickShareReport') {
            setTrimmedFilterDataOptionsSearchInsightsReport(filterData, reportSchema.Filters, entitySchema, setEntitySchema);
          }
          onFilterChange({
            filters: {
              ...editableFilter,
            },
          });
        }}
        removeAppliedFilter={_.noop}
        editableFilter={filters}
        schemaI18n={new SchemaI18n({ i18n })}
        readOnlyProperties={entitySchema.readOnlyProperties}
      />
    </div>
  );
}


FilterViewManagerWrapper.propTypes = {
  toolbarEditor: PropTypes.shape({
    update: PropTypes.func,
  }).isRequired,
  reportSchema: PropTypes.shape({
    ReportType: PropTypes.string,
    Filters: PropTypes.shape({}),
  }).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  resetToolbarVisibility: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};
